import { render, staticRenderFns } from "./AnnounceComponent.vue?vue&type=template&id=48399168&scoped=true"
import script from "./AnnounceComponent.vue?vue&type=script&lang=js"
export * from "./AnnounceComponent.vue?vue&type=script&lang=js"
import style0 from "./AnnounceComponent.vue?vue&type=style&index=0&id=48399168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48399168",
  null
  
)

export default component.exports